import { render, staticRenderFns } from "./BatteryListTabView.vue?vue&type=template&id=3ce1afbb&scoped=true&"
import script from "./BatteryListTabView.vue?vue&type=script&lang=ts&"
export * from "./BatteryListTabView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1afbb",
  null
  
)

export default component.exports